import { ComponentSelector, Slot } from '@thd-olt-component-react/component-selector';
import { ContentSection } from '@thd-olt-component-react/content-section';
import { Endcap } from '@thd-olt-component-react/endcap';
import { Hero } from '@thd-olt-component-react/hero';
import { MedioInline, PiccolaPencil } from '@thd-olt-component-react/internal-marketing-banner';
import { RelatedSearch } from '@thd-olt-component-react/related-search';
import { Resource } from '@thd-olt-component-react/resource';
import { ContentGalleryCard } from '@thd-olt-component-react/content-gallery-card';
import { SpecialBuyBanner } from '@thd-olt-component-react/special-buy-banner';
import { EmtDescription } from '@thd-olt-component-react/emt-generated-content';
import { EmtLinks } from '@thd-olt-component-react/emt-links';
import { SideNavigation } from '@thd-olt-component-react/side-navigation';
import { BasicPLA, BasicSponsoredBanner } from '@thd-olt-component-react/sponsored-content';
import { Spotlight } from '@thd-olt-component-react/spotlight';
import { PromoVisualNavigation, VisualNavigation } from '@thd-olt-component-react/visual-navigation';
import { ProductShelf } from '@thd-olt-component-react/product-shelf';

const buildComponentMapperObj = () => {
  const contentfulTypeToComponentMap = {
    ComponentSelector,
    Description_New: EmtDescription,
    Gallery: ContentGalleryCard,
    Hero,
    HeroCarousel: ContentSection,
    MedioInline,
    PiccolaPencil,
    ProductShelf,
    RelatedSearchesAndProducts: RelatedSearch,
    Resource,
    Section: ContentSection,
    SeoLinks: EmtLinks,
    SideNavigation,
    Slot,
    SponsoredBottomCarousel: BasicPLA,
    SponsoredMiddleBanner: BasicSponsoredBanner,
    SponsoredSkyscraperBanner: BasicSponsoredBanner,
    SponsoredTopBanner: BasicSponsoredBanner,
    Spotlight,
    VisualNavigation,
    PromoVisualNavigation,
    SpecialBuyOfTheDay: SpecialBuyBanner,
    EndCap: Endcap
  };

  const contentfulKeyToContentKeyMap = {
    descriptionNew: 'Description_New',
    dynamicSections: 'dynamicSections',
    gallery: 'gallery',
    heroCarousel: 'heroCarousel',
    productShelf: 'ProductShelf',
    relatedSearchesAndProducts: 'RelatedSearchesAndProducts',
    resourcesSection: 'resourcesSection',
    seoLinks: 'SeoLinks',
    sideNavigation: 'SideNavigation',
    sponsoredBottomCarousel: 'SponsoredBottomCarousel',
    sponsoredMiddleBanner: 'SponsoredMiddleBanner',
    sponsoredSkyscraperBanner: 'SponsoredSkyscraperBanner',
    sponsoredTopBanner: 'SponsoredTopBanner',
    spotlightSection: 'spotlightSection',
    specialBuyOfTheDay: 'SpecialBuyOfTheDay',
    endCap: 'EndCap'
  };

  const contentfulKeys = Object.keys(contentfulKeyToContentKeyMap);

  return {
    getComponentMap: () => {
      return contentfulTypeToComponentMap;
    },
    getComponent: (contentfulType) => {
      return contentfulTypeToComponentMap[contentfulType];
    },
    isValidKey: (contentfulKey) => {
      return contentfulKeys.includes(contentfulKey);
    },
    getContentKey: (contentfulKey) => {
      return contentfulKeyToContentKeyMap[contentfulKey];
    }
  };
};

export const componentMapper = buildComponentMapperObj();
